// Copyright ©️ 2026 eVolve MEP, LLC

import type { ColDef } from 'ag-grid-enterprise';

import { CellRenderer } from 'components/Mantine/CellRenderer';
import { convertSecondsToDuration } from 'components/Mantine/durationHelpers';

export const hoursColDef = <T,>() =>
  ({
    valueFormatter: ({ value }: { value: number | undefined }) => ((value ?? 0) / 60 / 60).toFixed(2),
    cellRenderer: CellRenderer<T, never, number | undefined>(({ value }) =>
      value ? convertSecondsToDuration(value) : '--',
    ),
  }) as const satisfies Pick<ColDef<T>, 'valueFormatter' | 'cellRenderer'>;
